import { useState } from 'react';

import { requestPasswordReset } from '../api/client.ts';
import { RouteLink } from '../studies/RouteLink.tsx';
import type { Route } from '../studies/routing.ts';
import { CheckEmailNotice } from './CheckEmailNotice.tsx';
import { EmailRequestForm } from './EmailRequestForm.tsx';

export interface ForgotPasswordViewProps {
  onNavigate: (route: Route) => void;
}

/** Asking for a reset link, which ends on the check-email screen whatever the address. */
export const ForgotPasswordView = ({ onNavigate }: ForgotPasswordViewProps) => {
  const [sentTo, setSentTo] = useState<string | null>(null);

  return (
    <main className="login" data-test-id="forgot-password-view">
      {sentTo === null ? (
        <>
          <h1>Reset your password</h1>
          <p>
            Enter the e-mail address you sign in with, and we will send a link to choose a new
            password.
          </p>
          <EmailRequestForm
            testIdPrefix="forgot-password"
            submitLabel="Send a reset link"
            pendingLabel="Sending…"
            send={requestPasswordReset}
            onSent={setSentTo}
          />
          <p className="login-links">
            <RouteLink
              to={{ name: 'studies' }}
              onNavigate={onNavigate}
              testId="forgot-password-sign-in"
            >
              Back to sign in
            </RouteLink>
          </p>
        </>
      ) : (
        <CheckEmailNotice email={sentTo} sendAgain={requestPasswordReset} onNavigate={onNavigate} />
      )}
    </main>
  );
};
